<div class="pagination-buttons">
  <button
    *ngIf="hasLoadMoreButton"
    app-vtmn-play-button
    type="button"
    class="pagination-buttons__button"
    [class.w-full]="isMobileDevice"
    [type]="ctaButtonType.Button"
    [size]="vtmnPlayButtonSize.MEDIUM"
    [variant]="vtmnPlayButtonVariant.PRIMARY"
    [shape]="
      isMobileDevice ? vtmnPlayButtonShape.SQUARED : vtmnPlayButtonShape.ROUNDED
    "
    loading
    (click)="loadMore.emit()"
  >
    {{ 'pagination_buttons.load_more' | translate }}
  </button>

  <ng-container *ngIf="!hasLoadMoreButton">
    <p class="pagination-buttons__text">
      {{
        (reviewsLabel
          ? 'pagination_buttons.text.all_reviews_displayed'
          : 'pagination_buttons.text.all_elements_displayed'
        ) | translate
      }}
    </p>

    <button
      app-vtmn-play-button
      type="button"
      [type]="ctaButtonType.Button"
      [size]="vtmnPlayButtonSize.MEDIUM"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="goBackUp()"
      class="pagination-buttons__button"
    >
      {{ 'pagination_buttons.button.go_back_up' | translate }}
    </button>
  </ng-container>
</div>
